<template>
    <div class="container">
        <div v-if="errors" v-for="error in errors">
            <div class="alert alert-danger" role="alert">{{ error}}</div>
        </div>

        <div class="loginPage">
            <div class="login">
                <form v-on:submit.prevent="login()">
                    <h1 class="h3 mb-3 font-weight-normal">Вход в В2В portal</h1>
                    <label for="inputEmail" class="sr-only">Email</label>
                    <input type="email" id="inputEmail" class="form-control" placeholder="Email" v-model="email"
                           required autofocus>
                    <label for="inputPassword" class="sr-only">Пароль</label>
                    <input type="password" id="inputPassword" class="form-control" placeholder="Пароль"
                           v-model="password" required>
                    <button class="btn btn-lg btn-primary btn-block btn-yellow" type="submit">Вход в В2В portal</button>
                </form>

                <div class="flx">
                    <router-link class="reg btn btn-primary" :to="'/register'">Регистрация</router-link>
                    <router-link class="reg btn btn-primary" :to="'/reset'">Забыли пароль?</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                email: '',
                password: '',
                errors: []
            }
        },
        mounted() {
            console.log(this.$auth.redirect());
            // Can set query parameter here for auth redirect or just do it silently in login redirect.
        },
        methods: {
            login() {
                // get the redirect object
                var redirect = this.$auth.redirect()
                var app = this
                this.$auth.login({
                    params: {
                        email: app.email,
                        password: app.password
                    },
                    success: function () {
                        if (this.$auth.check(['admin', 'manager', 'user', 'user.wholesale'])){
                            const user = this.$auth.user().role;
                            const redirectTo = this.$auth.check(['admin', 'manager']) ? user.charAt(0).toUpperCase() + user.substr(1) + 'Menu' : 'Order';
                            this.$router.push({name: redirectTo})
                        }else {
                            this.errors = ['У вас нет доступа на сайт']
                            this.$auth.logout()
                        }




                    },
                    errors: function () {
                       console.log('errors')
                    },
                    rememberMe: false,
                    fetchUser: true
                }).then(response =>{
                    if (response.data.errors){
                        this.errors = response.data.errors
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .btn-yellow{
        background-color: #e8d800;
        color: #000;
        box-shadow: none!important;
        border: 0;
    }

    .btn-yellow:hover{
         background-color: #000;
         color: #fff;
     }

    .flx{
        margin: 15px 0;
        display: flex;
        justify-content: space-between;
    }

    .reg{
        color: #fff;
        font-size: 16px;
    }

    .form-signin .form-control {
        position: relative;
        box-sizing: border-box;
        height: auto;
        padding: 10px;
        font-size: 16px;
    }

    .form-signin .form-control:focus {
        z-index: 2;
    }

    .form-signin input[type="email"] {
        margin-bottom: -1px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }

    .form-signin input[type="password"] {
        margin-bottom: 10px;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    input {
        margin: 15px 0;
    }

    .loginPage {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
    }

    .login {
        width: 350px;
    }
</style>



// WEBPACK FOOTER //
// src/views/app/pages/auth/Login.vue